import catalogContexts from "@utils/constants/catalogContexts";

export default function getInitPersonalised(
  listingPageSearchQuery,
  routerQuery,
  context,
  productsRented,
  productsLiked,
  productsUserList,
) {
  let initCheckedPersonalised = "all";
  let initFiltersConfigure = "";
  let likedQuery = "";
  let personalisedQuery = "";

  if (
    context === catalogContexts.wishlist ||
    listingPageSearchQuery?.includes("personalised[]=in_wishlist")
  ) {
    if (productsLiked?.length) {
      likedQuery = productsLiked?.map((id) => `id:${id}`).join(" OR ");
    } else {
      likedQuery = "id:NO_LIKED_PRODUCTS_EXCEPTION";
    }
  } else if (context === catalogContexts.userlist) {
    if (productsUserList?.length) {
      likedQuery = productsUserList?.map((id) => `id:${id}`).join(" OR ");
    } else {
      likedQuery = "id:NO_USERLIST_PRODUCTS_EXCEPTION";
    }
  }

  if (
    productsRented?.length &&
    (listingPageSearchQuery?.includes("personalised[]=not_rented") ||
      routerQuery?.["personalised[]"] === "not_rented")
  ) {
    initCheckedPersonalised = "not_rented";
    personalisedQuery = `NOT ${productsRented?.map((id) => `id:${id}`).join(" AND NOT ")}`;
  } else if (
    listingPageSearchQuery?.includes("personalised[]=rented") ||
    routerQuery?.["personalised[]"] === "rented"
  ) {
    initCheckedPersonalised = "rented";
    if (productsRented?.length) {
      personalisedQuery = productsRented?.map((id) => `id:${id}`).join(" OR ");
    } else {
      personalisedQuery = "id:NO_RENTED_PRODUCTS_EXCEPTION";
    }
  }

  if (likedQuery) {
    initFiltersConfigure = personalisedQuery
      ? `${likedQuery} AND (${personalisedQuery})`
      : likedQuery;
  } else {
    initFiltersConfigure = personalisedQuery;
  }


  return { initCheckedPersonalised, initFiltersConfigure };
}
